import View from './View';

export { default as BasePaginator } from './View';
export default View;